// Styles Tailwind
import "@/assets/css/tailwind.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBookOpen,
  faCircleInfo,
  faDesktop,
  faDoorOpen,
  faDownLong,
  faExpand,
  faForward,
  faGear,
  faHatWizard,
  faLeftLong,
  faMinimize,
  faRightLong,
  faShapes,
  faUpLong,
  faVolumeHigh,
  faVolumeOff,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// MDI ICONS
import "@mdi/font/css/materialdesignicons.css";
import "sweetalert2/dist/sweetalert2.min.css";
import Vue from "vue";
//src/main.js
import GAuth from "vue-google-oauth2";
// Sweet Alets
import VueSweetalert2 from "vue-sweetalert2";
import "vuetify/dist/vuetify.min.css";
import App from "./App.vue";
// Vuetify
import vuetify from "./plugins/vuetify";
import router from "./router";
library.add(
  faHatWizard,
  faGear,
  faExpand,
  faVolumeHigh,
  faMinimize,
  faForward,
  faShapes,
  faDoorOpen,
  faUpLong,
  faRightLong,
  faLeftLong,
  faDownLong,
  faDesktop,
  faCircleInfo,
  faBookOpen,
  faVolumeOff
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

const gauthOption = {
  clientId:
    "580411293057-pi7ogq2e69lqjsm51j65gses0asq4lm6.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "consent",
  fetch_basic_profile: true,
};
Vue.use(GAuth, gauthOption, VueSweetalert2);

Vue.config.productionTip = false;

Vue.prototype.$getDataProfile = function (token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
};
Vue.prototype.$launchAudio = function (music) {
  let audio = music;
  audio.play();
  return false;
};
Vue.prototype.$muteAudio = function (music) {
  let audio = music;
  audio.pause();
  return true;
};

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
